import React from 'react'
import { Formik } from 'formik'
import { Col, Row, Toast } from 'react-bootstrap'
import { StyledInput, StyledTextarea, StyledTitle, StyledInputMask, StyledError } from './styled'
import { Button } from './../../components'
import * as Yup from 'yup'
import { sendContact } from './../../core/api/mailer-provider'

const ContactForm = (props) => {

    const [show, setShow] = React.useState(false);
    const [message, setMessage] = React.useState('');
    const [loading, setLoading] = React.useState(false);

    return (
        <>
            {
                props?.title 
                ? (
                    <Col xs={12} className='d-flex justify-content-center'>
                        <StyledTitle>
                            {props.title}
                        </StyledTitle>
                    </Col>
                )
                : ''
            }
            <Formik
            initialValues={{
                firstName: '',
                lastName: '',
                company: '',
                email: '',
                phone: '',
                cellphone: '',
                subject: '',
                content: ''
            }}
            validationSchema={Yup.object({
                firstName: Yup.string().required('* Campo obrigatório'),
                lastName: Yup.string().required('* Campo obrigatório'),
                company: Yup.string().required('* Campo obrigatório'),
                email: Yup.string().required('* Campo obrigatório'),
                phone: Yup.string().required('* Campo obrigatório'),
                cellphone: Yup.string().required('* Campo obrigatório'),
                subject: Yup.string().required('* Campo obrigatório'),
                content: Yup.string().required('* Campo obrigatório'),
            })}
            onSubmit={(values, helper) => {
                setLoading(true)
                sendContact({
                    subject: values.subject,
                    // mailto: 'dgbarbosa96@gmail.com',
                    mailto: 'contato.fr@fr-instalacoes.com.br',
                    body: `
                        <p style='font-weight: bold; font-size: 16px;'>${values.subject}</p>
                        <p>Nome: ${values.firstName}</p>
                        <p>Sobrenome: ${values.lastName}</p>
                        <p>Empresa: ${values.company}</p>
                        <p>E-mail: ${values.email}</p>
                        <p>Telefone: ${values.phone}</p>
                        <p>Celular: ${values.cellphone}</p>
                        <p>Conteúdo: </p>
                        <p>${values.content}</p>
                    `
                })
                .then(() => {
                    setShow(true)
                    setMessage('Email enviado com sucesso')
                    setLoading(false)
                    helper.resetForm()
                })
                .catch(() => {
                    setShow(true)
                    setMessage('Falha ao enviar o email')
                    setLoading(false)
                })
            }}
        >
            {
                ({
                    handleSubmit,
                    handleChange,
                    touched,
                    errors,
                    values
                }) => (
                    <form onSubmit={handleSubmit}>
                        <Row className='mx-0 px-0'>
                            <Col 
                                md={{
                                    span: 5,
                                    offset: 1
                                }}
                                xs={12}
                                className='d-flex mb-4 flex-column'
                            >
                                <StyledInput
                                    type='text'
                                    name='firstName'
                                    placeholder='Nome'
                                    onChange={handleChange}
                                    value={values.firstName}
                                    disabled={loading}
                                />
                                {errors.firstName && touched.firstName && <StyledError>{errors.firstName}</StyledError>}
                            </Col>
                            <Col
                                md={{
                                    span: 5
                                }}
                                xs={12}
                                className='d-flex mb-4 flex-column'
                            >
                                <StyledInput
                                    type='text'
                                    name='lastName'
                                    placeholder='Sobrenome'
                                    onChange={handleChange}
                                    value={values.lastName}
                                    disabled={loading}
                                />
                                {errors.lastName && touched.lastName && <StyledError>{errors.lastName}</StyledError>}
                            </Col>
                        </Row>

                        <Row className='mx-0 px-0'>
                            <Col
                                md={{
                                    span: 5,
                                    offset: 1
                                }}
                                xs={12}
                                className='d-flex mb-4 flex-column'
                            >
                                <StyledInput
                                    type='text'
                                    name='company'
                                    placeholder='Empresa'
                                    onChange={handleChange}
                                    value={values.company}
                                    disabled={loading}
                                />
                                {errors.company && touched.company && <StyledError>{errors.company}</StyledError>}
                            </Col>
                            <Col
                                md={{
                                    span: 5
                                }}
                                xs={12}
                                className='d-flex mb-4 flex-column'
                            >
                                <StyledInput
                                    type='text'
                                    name='email'
                                    placeholder='E-mail'
                                    onChange={handleChange}
                                    value={values.email}
                                    disabled={loading}
                                />
                                {errors.email && touched.email && <StyledError>{errors.email}</StyledError>}
                            </Col>
                        </Row>

                        <Row className='mx-0 px-0'> 
                            <Col
                                md={{
                                    span: 5,
                                    offset: 1
                                }}
                                xs={12}
                                className='d-flex mb-4 flex-column'
                            >
                                <StyledInputMask
                                    name='phone'
                                    placeholder='Telefone'
                                    onChange={handleChange}
                                    value={values.phone}
                                    mask='(99) 9999-9999'
                                    disabled={loading}
                                />
                                {errors.phone && touched.phone && <StyledError>{errors.phone}</StyledError>}
                            </Col>
                            <Col
                                md={{
                                    span: 5
                                }}
                                xs={12}
                                className='d-flex mb-4 flex-column'
                            >
                                <StyledInputMask
                                    name='cellphone'
                                    placeholder='Celular'
                                    onChange={handleChange}
                                    value={values.cellphone}
                                    mask='(99) 99999-9999'
                                    disabled={loading}
                                />
                                {errors.cellphone && touched.cellphone && <StyledError>{errors.cellphone}</StyledError>}
                            </Col>
                        </Row>

                        <Row className='px-0 mx-0'>
                            <Col
                                md={{
                                    span: 10,
                                    offset: 1
                                }}
                                xs={12}
                                className='d-flex mb-4 flex-column'
                            >
                                <StyledInput
                                    type='text'
                                    name='subject'
                                    placeholder='Assunto'
                                    onChange={handleChange}
                                    value={values.subject}
                                    disabled={loading}
                                />
                                {errors.subject && touched.subject && <StyledError>{errors.subject}</StyledError>}
                            </Col>
                        </Row>

                        <Row className='px-0 mx-0'>
                            <Col
                                md={{
                                    span: 10,
                                    offset: 1
                                }}
                                xs={12}
                                className='d-flex flex-column'
                            >
                                <StyledTextarea placeholder='Escrever' name='content' onChange={handleChange} value={values.content} rows="10" disabled={loading}>
                                </StyledTextarea>
                                {errors.content && touched.content && <StyledError bottom='-10'>{errors.content}</StyledError>}
                            </Col>
                        </Row>

                        <Row className='mt-4 mx-0 px-0'>
                            <Col
                                md={{
                                    span: 10,
                                    offset: 1
                                }}
                                xs={12}
                                className='d-flex justify-content-end'
                            >
                                <Button disabled={loading} label='Enviar'/>
                            </Col>
                        </Row>
                            
                    </form>
                )
            }
        </Formik>
        <div style={{position: 'fixed', bottom: 0, zIndex: 999, left: '50%', transform: 'translateX(-50%)'}}>
            <Toast onClose={() => setShow(false)} show={show} delay={3000} autohide>
            <Toast.Body>{message}</Toast.Body>
            </Toast>

        </div>
        </>
    )
}

export default ContactForm